import { EMPTY_OBJECT } from '../../constants/common'
import { deleteApi, getApi, patchApi, postApi } from '../../utils/api'

import { EMAIL_ACCOUNTS_API_PAGE_SIZE } from './Email.constants'
import { getEmailApiEntityType } from './Email.utils'

export function getEmailAccountsMenu(apiParams) {
  return getApi({
    endpoint: 'api/mail-account/menu/',
    params: {
      ...apiParams,
      page_size: EMAIL_ACCOUNTS_API_PAGE_SIZE,
    },
  })
}

export function createEmailThread(data) {
  return postApi({ data, endpoint: `api/email-thread/` })
}

export function createEmailMessage(data) {
  return postApi({ data, endpoint: `api/email-message/` })
}

export function updateEmail(id, data, single) {
  return patchApi({
    data,
    endpoint: `api/${single ? 'email-message' : 'email-thread'}/${id}/`,
  })
}

export function performEmailMassAction(data, singleEmail) {
  return postApi({
    data,
    endpoint: `idwell-api/api/v3/email/${getEmailApiEntityType(singleEmail)}/mass-action/`,
  })
}

export function getEmailAccountsSimple(params) {
  return getApi({
    endpoint: '/api/mail-account/simple/',
    params,
  })
}

export function reconnectEmailAccount(id) {
  return postApi({
    endpoint: `api/mail-account/mail-integration/${id}/reconnect/`,
  })
}

export function getEmailTemplates(params) {
  return getApi({
    endpoint: '/api/text-module/email-snippet/',
    params,
  })
}

export function getEmailGoogleTemplates(search, apiParams = EMPTY_OBJECT) {
  const params = { ...(search ? { search } : null) }

  return getApi({
    endpoint: 'api/doc-templates/google-templates/',
    params: {
      ...apiParams,
      ...params,
    },
  })
}

export function getEmailExternalVariables(template) {
  return getApi({
    endpoint: `/api/doc-templates/google-templates/${template}/get-external-vars/`,
  })
}

export function refreshEmailGoogleTemplates() {
  return postApi({ endpoint: 'api/doc-templates/google-templates/refresh/' })
}

export function testEmailGoogleTemplateVariables(data) {
  return postApi({
    data,
    endpoint: 'api/doc-templates/google-templates/analyze-variables/',
  })
}

export function testEmailTextTemplateVariables(id, data) {
  return postApi({
    data,
    endpoint: `api/text-module/email-snippet/${id}/analyze-variables/`,
  })
}

export function createEmailPreviewTemplateMessageText(id, data) {
  return postApi({
    data,
    endpoint: `api/text-module/email-snippet/${id}/render-preview/`,
  })
}

export function testEmailVariablesStatus(eventId) {
  return getApi({
    endpoint: `api/text-module/analyze-variables-status/${eventId}/`,
  })
}

export function getEmailGoogleTemplatePreview(data) {
  return postApi({
    data,
    endpoint: 'api/doc-templates/google-templates/preview/',
  })
}

export function getEmailAccountFont(accountId) {
  return getApi({ endpoint: `api/email-font/${accountId}/` })
}

export function searchEmails({
  apiConfig = EMPTY_OBJECT,
  archived = false,
  query,
}) {
  return getApi({
    ...apiConfig,
    endpoint: 'api/email-message/live-search/',
    params: { ...apiConfig.params, archived, query },
  })
}

export function checkEmailBlackList(data) {
  return postApi({ data, endpoint: '/api/check-blacklist/' })
}

export function checkEmailActionTaskStatus(id) {
  return getApi({ endpoint: `api/system/async_task/${id}/` })
}

export function getEmailMessageProfile(uuid, params) {
  return getApi({ endpoint: `api/email-message/${uuid}/`, params })
}

export function getEmailMessageFiles({ object_id: uuid, ...restParams }) {
  return getApi({
    endpoint: `api/email-message/${uuid}/files/`,
    params: restParams,
  })
}

export function getEmailMessageRaw(uuid, params) {
  return getApi({ endpoint: `api/email-message/${uuid}/raw-text/`, params })
}

export function getEmailMessages({ options, params }) {
  return getApi({
    endpoint: 'idwell-api/api/v3/email/email-messages/',
    options,
    params,
  })
}

export function getEmailThreadProfile({ options, params, uuid }) {
  return getApi({
    endpoint: `idwell-api/api/v3/email/email-threads/${uuid}/`,
    options,
    params,
  })
}

export function getEmailThreadNavigation({ data, options, uuid }) {
  return postApi({
    data,
    endpoint: `idwell-api/api/v3/email/email-threads/${uuid}/navigation/`,
    options,
  })
}

export function getEmailMessageNavigation({ data, options, uuid }) {
  return postApi({
    data,
    endpoint: `idwell-api/api/v3/email/no-thread-view-email-messages/${uuid}/navigation/`,
    options,
  })
}

export function getEmailThreadFiles({ object_id: uuid, ...restParams }) {
  return getApi({
    endpoint: `api/email-thread/${uuid}/files/`,
    params: restParams,
  })
}

export function getEmailProfileWidgetsInfo(params, apiConfig) {
  return getApi({
    ...apiConfig,
    endpoint: 'idwell-api/api/v3/email/email-messages/widgets-info/',
    params,
  })
}

export function resendEmail(uuid) {
  return postApi({
    data: { uuid },
    endpoint: `api/email-message/${uuid}/resend/`,
  })
}

export function toggleEmailRead({ options, read, single, uuid }) {
  return postApi({
    endpoint: `api/${single ? 'email-message' : 'email-thread'}/${uuid}/${read ? 'read' : 'unread'}/`,
    options,
  })
}

export function deleteEmailMessage({ id, params }) {
  return deleteApi({
    endpoint: `api/email-message/${id}/`,
    params,
  })
}

export function getMyUnreadEmails(params) {
  return getApi({
    endpoint: 'idwell-api/api/v3/widget/widgets/unread-emails/',
    params,
  })
}

export function getEmailAvailableUserProfiles(params) {
  return getApi({
    endpoint: 'idwell-api/api/v3/email/email-archives/available-user-profiles/',
    params,
  })
}

export function copyEmailToEntity({ data, uuid }) {
  return postApi({
    data,
    endpoint: `api/email-message/${uuid}/copy_to_archive/`,
  })
}

export function deleteEmailCopiedEntity({ data, uuid }) {
  return postApi({
    data,
    endpoint: `api/email-message/${uuid}/delete_from_archive/`,
  })
}
